
const StatsSection = () => {
  const stats = [
    {
      number: '20+',
      label: 'Expert Engineers',
      description: 'Chemical, process, and materials specialists'
    },
    {
      number: '500+',
      label: 'Projects Completed',
      description: 'Successful chemical solutions delivered'
    },
    {
      number: '15+',
      label: 'Years Experience',
      description: 'Industry expertise and innovation'
    },
    {
      number: '99%',
      label: 'Client Satisfaction',
      description: 'Proven track record of excellence'
    }
  ];

  return (
    <section className="py-20 bg-teal-600">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            Trusted by Industry Leaders
          </h2>
          <p className="text-xl text-teal-100 max-w-3xl mx-auto">
            Our track record speaks for itself. We've helped hundreds of companies 
            optimize their operations with innovative chemical solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-5xl font-bold text-white mb-2">{stat.number}</div>
              <div className="text-xl font-semibold text-teal-100 mb-2">{stat.label}</div>
              <div className="text-teal-200">{stat.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
